import { Typography } from "@mui/material";
import { useMemo } from "react";

type CurrencyProps = {
  symbol?: string;
  amount: number;
  variant?: "small" | "medium" | "large";
};

export default function Currency({
  symbol,
  amount,
  variant = "small",
}: CurrencyProps) {
  const sizeVariant = useMemo(() => {
    if (variant === "large") return "h4";
    if (variant === "medium") return "h6";
    return "inherit";
  }, [variant]);

  console.log(sizeVariant);
  return (
    <Typography variant={sizeVariant}>
      <span style={{ fontSize: 10, color: "grey" }}>{symbol ?? "GHS"}</span>
      {Number(amount).toFixed(2)}
    </Typography>
  );
}
